import { BASE_URL } from "@funded-here-interface/common/src/constant/constant";
import axios from "axios";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";

interface DeleteFileRequest {
  token: string;
  filePath: string;
}

const deleteFile = async ({ token, filePath }: DeleteFileRequest) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/trade-directory/upload/delete`,
      { filePath },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (e) {
    const message = getApiResponseErrorMsg(e);

    throw new Error(message);
  }
};

export default deleteFile;
